import { format } from "date-fns";

export const COLUMNS = [
    {
        Header: 'Ime i prezime',
        accessor: 'name'
    },
    {
        Header: 'Broj kartice',
        accessor: 'personalCardNumber'
    },
    {
        Header: 'Potreban novi plan',
        accessor: 'needsAPlan',
        Cell: ({ row }) => (
            <div className="flex">
                <span>{row.original["needsAPlan"] ? 'Da' : 'Ne'}</span>
            </div>
        )
    },
]